module.exports = __webpack_public_path__ + "static/media/smell.f59bfc9f.svg";